<script setup>
import weekSlider from '@/components/object_placeCollection/weekSlider.vue'
import weekTable from '@/components/object_placeCollection/weekTable.vue'
import dayOverview from '@/components/object_placeCollection/dayOverview.vue'
import dayOverviewSimple from '@/components/object_placeCollection/dayOverviewSimple.vue'
import CustomLinks from '@/components/reuseables/customLinks.vue'
import { onMounted, ref, defineProps } from 'vue'
import axios from 'axios'

const components = {
    weekSlider,
    weekTable,
    dayOverview,
    dayOverviewSimple
}

const placeInformation = ref(null)

const props = defineProps({
    data: Object,
})

async function fetchPlaceData() {
    try {
        const projectIdentifier = process.env.VUE_APP_PROJECT_NAME
        const apiUrl = process.env.VUE_APP_API_URL
        const collectionId = props.data.id

        const response = await axios.get(`${apiUrl}/api/${projectIdentifier}/place-information/${collectionId}`, {
            headers: {
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                'Pragma': 'no-cache',
                'Expires': '0'
            }
        })
        placeInformation.value = response.data
    } catch (error) {
        console.error('Error fetching place information:', error)
    }
}

onMounted(fetchPlaceData)
</script>

<template>
    <component
        v-if="placeInformation && components[data.template]"
        :is="components[data.template]"
        :id="data.template + '-' + data.id"
        :place-information="placeInformation"
        class="place-collection"
    />

    <custom-links :links="data.links"/>
</template>

<style>
.place-collection + a {
    width: auto;
    background: none;
    margin-top: 0.5rem;
}
</style>
